import {
  Container,
  Grid,
  Button,
  Grow,
  Typography,
  useTheme,
  Box,
  Slide,
  Fade,
  makeStyles,
  ButtonBase
} from "@material-ui/core";
import { useState, useEffect } from "react";
import Axios from "axios";
import { Helmet } from "react-helmet-async";
import { Loading } from "../../components/shared/loading";
import parse from "html-react-parser";
import { Link } from "react-router-dom";
import Card from "@material-ui/core/Card";
import CardMedia from "@material-ui/core/CardMedia";
import CardContent from "@material-ui/core/CardContent";

const headKey = "qweqeasdj123n1jasndjn2j3njsdn12i891bdjsdu1283djsd1231231";

const useStyles = makeStyles((theme) => ({
  heroSection: {
    backgroundImage: 'linear-gradient(rgba(76, 0, 76, 0.85), rgba(76, 0, 76, 0.9)), url("/static/services.jpg")',
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundAttachment: "fixed",
    minHeight: "35vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  heroContent: {
    textAlign: "center",
    color: "#ffffff",
    padding: "40px 20px",
    maxWidth: 700,
  },
  heroTitle: {
    fontSize: "clamp(1.8rem, 4vw, 2.5rem)",
    fontWeight: 700,
    marginBottom: 10,
    textShadow: "0 2px 15px rgba(0,0,0,0.3)",
  },
  heroDivider: {
    width: 40,
    height: 2,
    background: "rgba(255,255,255,0.5)",
    margin: "12px auto",
    borderRadius: 2,
  },
  heroSubtitle: {
    fontSize: "clamp(0.85rem, 1.5vw, 1rem)",
    fontWeight: 400,
    opacity: 0.9,
    maxWidth: 500,
    margin: "0 auto",
    lineHeight: 1.5,
  },
  nounderline: {
    "&:hover": { textDecoration: "none" },
    width: "100%",
  },
  section: {
    padding: "40px 0",
    background: "#fafafa",
  },
  sectionWhite: {
    padding: "40px 0",
    background: "#ffffff",
  },
  sectionTitle: {
    fontSize: "1.4rem",
    fontWeight: 600,
    color: "#4c004c",
    textAlign: "center",
    marginBottom: 8,
  },
  sectionSubtitle: {
    fontSize: "0.85rem",
    color: "#666666",
    textAlign: "center",
    maxWidth: 450,
    margin: "0 auto 28px",
    lineHeight: 1.5,
  },
  serviceCard: {
    background: "#ffffff",
    borderRadius: "12px",
    overflow: "hidden",
    height: "100%",
    transition: "all 0.2s ease",
    boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
    border: "1px solid rgba(76, 0, 76, 0.08)",
    "&:hover": {
      transform: "translateY(-4px)",
      boxShadow: "0 8px 24px rgba(107, 27, 107, 0.1)",
    },
  },
  serviceImage: {
    height: 140,
    [theme.breakpoints.down('sm')]: {
      height: 120,
    },
  },
  serviceContent: {
    padding: "16px",
  },
  serviceTitle: {
    fontSize: "0.9rem",
    fontWeight: 600,
    color: "#4c004c",
    marginBottom: 8,
  },
  serviceDesc: {
    fontSize: "0.78rem",
    color: "#666666",
    lineHeight: 1.5,
  },
  techSection: {
    padding: "32px 0",
    background: "#ffffff",
  },
  techTitle: {
    fontSize: "1.2rem",
    fontWeight: 600,
    color: "#4c004c",
    textAlign: "center",
    marginBottom: 6,
  },
  techSubtitle: {
    fontSize: "0.8rem",
    color: "#666666",
    textAlign: "center",
    marginBottom: 24,
  },
  techLogo: {
    height: 60,
    objectFit: "contain",
    width: "100%",
    padding: 8,
    transition: "all 0.2s ease",
    "&:hover": {
      transform: "scale(1.1)",
    },
    [theme.breakpoints.down('sm')]: {
      height: 50,
    },
  },
  quoteSection: {
    background: "linear-gradient(135deg, #6b1b6b 0%, #4a0e4a 100%)",
    borderRadius: "12px",
    padding: "28px 24px",
    marginTop: 32,
    textAlign: "center",
  },
  quoteText: {
    fontSize: "0.9rem",
    color: "#ffffff",
    lineHeight: 1.6,
    fontStyle: "italic",
    maxWidth: 700,
    margin: "0 auto 12px",
  },
  quoteAuthor: {
    color: "#ffffff",
    fontSize: "0.8rem",
    fontWeight: 600,
    opacity: 0.9,
  },
}));

export const Services = () => {
  const theme = useTheme();

  const classes = useStyles();

  const [metaTitle, setMetaTitle] = useState("");
  const [metaDesc, setMetaDesc] = useState("");
  const [metaKeywords, setMetaKeywords] = useState("");
  const [isloading, setIsloading] = useState(true);
  const [services, setServices] = useState();
  //const [checked, setChecked] =  useState(true);

  const handleClick = () => {
    const anchor = document.querySelector("#back-to-top-anchor");

    if (anchor) {
      anchor.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  };

  useEffect(() => {
    getMetaData();
  }, []);

  const getMetaData = () => {
    const formData = new FormData();
    formData.append("page", 2);
    Axios.get("/api/getservices", {
      headers: { headKey: headKey },
    }).then((res) => {
      if (res.data.status) {
        setServices(res.data.data);
      }
    });
    Axios.post("/api/getmetadata", formData, {
      headers: { headKey: headKey },
    }).then((res) => {
      if (res.data.status) {
        setMetaTitle(res.data.data.meta_title);
        setMetaKeywords(res.data.data.meta_keywords);
        setMetaDesc(res.data.data.meta_desc);
        setIsloading(false);
        handleClick();
      }
    });
  };

  
  return (
    <div>
      <Helmet>
        <title>{metaTitle}</title>
        <meta name="description" content={metaDesc} />
        <meta name="keywords" content={metaKeywords}></meta>
      </Helmet>
      {/* Hero Section */}
      <Box className={classes.heroSection}>
        <Fade in={true} timeout={1000}>
          <Box className={classes.heroContent}>
            <Typography className={classes.heroTitle}>
              Our Services
            </Typography>
            <Box className={classes.heroDivider} />
            <Typography className={classes.heroSubtitle}>
              Elevate Your Business with Our Comprehensive IT Solutions
            </Typography>
          </Box>
        </Fade>
      </Box>

      {isloading ? (
        <Loading />
      ) : (
        <>
        <Box className={classes.section}>
          <Container maxWidth="lg">
            <Slide direction="up" in={true} timeout={800}>
              <Box>
                <Typography className={classes.sectionTitle}>
                  Solutions Crafted for Success
                </Typography>
                <Typography className={classes.sectionSubtitle}>
                  Explore the breadth of our expertise and customized IT services
                </Typography>
              </Box>
            </Slide>
            {services && (
              <Grid container spacing={3}>
                {services.map((service, index) => {
                  let serv_dec = parse(service.serv_desc.substring(0, 120) + "...");
                  return (
                    <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                      <Grow in={true} timeout={600 + index * 100}>
                        <ButtonBase
                          className={classes.nounderline}
                          component={Link}
                          to={
                            "/service-details/" +
                            service.serv_name.split(" ").join("-") +
                            "/" +
                            service.serv_id
                          }
                        >
                          <Card className={classes.serviceCard}>
                            <CardMedia
                              className={classes.serviceImage}
                              image={"/static/services/" + service.serv_image}
                              title={service.serv_name}
                            />
                            <Box className={classes.serviceContent}>
                              <Typography className={classes.serviceTitle}>
                                {service.serv_name}
                              </Typography>
                              <Typography className={classes.serviceDesc}>
                                {serv_dec}
                              </Typography>
                            </Box>
                          </Card>
                        </ButtonBase>
                      </Grow>
                    </Grid>
                  );
                })}
              </Grid>
            )}
          </Container>
        </Box>

        {/* Technologies Section */}
        <Box className={classes.sectionWhite}>
          <Container maxWidth="lg">
            <Typography className={classes.techTitle}>
              Technologies We Use
            </Typography>
            <Typography className={classes.techSubtitle}>
              Cutting-edge tools and platforms powering our solutions
            </Typography>

            <Fade in={true} timeout={1000}>
              <Grid container spacing={2} justifyContent="center">
                {[
                  { name: "NodeJs", src: "nodejs.png" },
                  { name: "Python", src: "python.png" },
                  { name: "Dart", src: "dart.png" },
                  { name: "ReactJs", src: "react.png" },
                  { name: "C#", src: "c-sharp.png" },
                  { name: "PHP", src: "php.png" },
                  { name: "ExpressJs", src: "express.png" },
                  { name: "Flask", src: "flask.png" },
                  { name: "Pyteal", src: "pyteal.png" },
                  { name: "Solidity", src: "solidity.png" },
                  { name: "Flutter", src: "flutter.png" },
                  { name: "Django", src: "django.png" },
                  { name: "CodeIgniter", src: "codeigniter.png" },
                  { name: "Xcode", src: "xcode.png" },
                  { name: "Android Studio", src: "androidstudio.png" },
                  { name: "Unity", src: "unity.png" },
                  { name: "JavaScript", src: "javascript.png" },
                  { name: "jQuery", src: "jquery.png" },
                  { name: "HTML", src: "html.png" },
                  { name: "CSS", src: "css.png" },
                  { name: "Bootstrap", src: "bootstrap.png" },
                  { name: "MongoDB", src: "mongodb.png" },
                  { name: "MySQL", src: "mysql.png" },
                  { name: "Firebase", src: "firebase.png" },
                ].map((tech, index) => (
                  <Grid item xs={3} sm={2} md={1} key={index}>
                    <img
                      alt={tech.name}
                      src={`/static/techs/${tech.src}`}
                      className={classes.techLogo}
                      title={tech.name}
                    />
                  </Grid>
                ))}
              </Grid>
            </Fade>

            {/* Quote Section */}
            <Fade in={true} timeout={1200}>
              <Box className={classes.quoteSection}>
                <Typography className={classes.quoteText}>
                  "As Managing Director and Architect of ESAY and AraFaceFinder, I witness firsthand the Arawinz team's blend of innovation and dedication. We're committed to excellence and shaping a smarter, more connected future."
                </Typography>
                <Typography className={classes.quoteAuthor}>
                  — Chethan. P. S. S, Managing Director
                </Typography>
              </Box>
            </Fade>
          </Container>
        </Box>
        </>
      )}
      
    </div>
  );
};

